import React, { lazy } from 'react';
import { CirclePlayIcon, QuoteIcon } from 'lucide-react';
import { CompanyPageLayout } from '../components/CompanyPageLayout';
const stories = [{
  name: 'Maya & James',
  journey: 'Manaslu Circuit',
  image: 'https://images.unsplash.com/photo-1528181304800-259b08848526?auto=format&fit=crop&w=1000&q=85',
  quote: 'A journey that made space for both the big moments and the small ones.'
}, {
  name: 'Anika',
  journey: 'Everest View Trek',
  image: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1000&q=85',
  quote: 'The support felt natural, warm, and exactly right for the trail.'
}];
export function VideoReviews() {
  return <CompanyPageLayout eyebrow="Video reviews" title="Hear the journey in travellers’ own words." intro="A collection of guest reflections on the people, mountain days, and quiet moments that shaped their time in Nepal." data-id="element-947">
      <section className="px-5 py-20 sm:px-8 sm:py-28 lg:px-12" data-id="element-948">
        <div className="mx-auto max-w-[980px]" data-id="element-949">
          <div className="aspect-video overflow-hidden bg-[#17362e]" data-id="element-950">
            <iframe className="h-full w-full" src="https://www.youtube-nocookie.com/embed/zWjhI5B2PyE" title="Guest reflections from a Himalayan journey" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-951" />
          </div>
          <div className="mt-5 border-l-4 border-[#6e9b70] bg-[#e1efdc] px-6 py-5" data-id="element-952">
            <p className="font-serif text-2xl leading-snug" data-id="element-953">
              “What we remember is not only the view, but how capable the team
              made us feel along the way.”
            </p>
          </div>
          <div className="mt-12 grid gap-6 sm:grid-cols-2" data-id="element-954">
            {stories.map(story => <article key={story.name} className="border-b border-[#cfd3c8] pb-6" data-id="element-955">
                <div className="relative overflow-hidden" data-id="element-956">
                  <img src={story.image} alt={`${story.journey} mountain landscape`} className="h-64 w-full object-cover" loading="lazy" data-id="element-957" />
                  <span className="absolute inset-0 flex items-center justify-center bg-[#17362e]/25" data-id="element-958">
                    <CirclePlayIcon className="h-14 w-14 fill-white text-white" aria-hidden="true" data-id="element-959" />
                  </span>
                </div>
                <p className="mt-5 text-[10px] font-bold uppercase tracking-[0.18em] text-[#4f8057]" data-id="element-960">
                  {story.journey}
                </p>
                <h2 className="mt-2 font-serif text-3xl" data-id="element-961">
                  {story.name}&apos;s story
                </h2>
                <p className="mt-3 flex gap-2 leading-7 text-[#52635a]" data-id="element-962">
                  <QuoteIcon className="mt-1 h-4 w-4 shrink-0 text-[#6e9b70]" aria-hidden="true" data-id="element-963" />
                  {story.quote}
                </p>
              </article>)}
          </div>
        </div>
      </section>
    </CompanyPageLayout>;
}